const setting = {
    id:'ID',
    //login list
    loginList: 'Login List',
    timeStamp: 'Timestamp',
    authenticatedBy: 'Authenticated by',
    status: 'Status',
    ipAddress: 'Ip Address',

    // headings
    createUser: 'Create new User',
    createPartner: 'Create Partner',
    createCampus: 'Create Campus',

    editRole: 'Edit Role',
    editUser: 'Edit User',
    editPartner: 'Edit Partner',
    editCampus: 'Edit Campus',

    // List
    roleList: "Role's List",
    roles: "Role(s)",
    userList: "User Accounts",
    partnerList: "Partner's List",
    campusList: "Campuses List",
    auditList: "Audit Log",
    lockedRecordList: "Locked Record List",

    name: "Name",
    action: "Action",
    username: "Username",
    email: "E-mail",
    authenticateBy: "Authenticate By",
    authenticateMethod: "Authentication Method",
    searchCriteria: 'Filter Preset',
    presetName: 'Enter Preset Name',
    google2FAMode: 'Two Factor Authentication Mode',
    status: 'Status',
    entity: "Entity",
    field: "Field",
    oldValue: "Old Value",
    newValue: "New Value",
    changedBy: "Changed by",
    changeDate: "Change Date",
    entity: "Entity",
    fieldID: "Field ID",
    editingBy: "Editing By",
    startedAt: "Started At",
    event: "Event",
    enabled: 'Enabled',
    enable: 'Enable',
    disabled: 'Disabled',
    disable: 'Disable',
    changeStatus: 'The field is disabled in case to prevent you blocking yourself.',
    tokenRevoke: "Token Revoke",
    // Labels
    availablePermissions: 'Available Permissions',
    selectAll: 'Select All',
    module: 'Module',
    enterFullName: 'Enter Full Name',
    enterEmail: 'Enter Email',
    enterUsername: 'Enter Username',
    enterPassword: 'Enter Password',
    confirmPassword: 'Confirm Password',
    passwordNotMatch: 'Password doesn\'t match.',
    selectAuthentication: '--Select Authentication--',
    leavePasswordFieldText: 'Leave Password field blank if do not want to change!',
    searchRole: 'Search or add a Role',
    fullName: 'Full Name',
    password: 'Password',
    partner: 'Partner',
    staff: 'Staff Record',
    authentication: 'Authentication',
    ldap: 'Ldap',
    local: 'Local',
    role: 'Role',
    disabled: 'Disabled',
    optional: 'Optional',
    enforced: 'Enforced',
    changedBy: 'Changed By',
    date: 'Date',
    event: 'Event',
    oldValue: 'Old Value',
    newValue: 'New Value',
    field: 'Field',
    auditIt: 'ID',

    // partners
    partnerCode: 'Partner Code',
    partnerName: 'Partner Name',
    partnerCampusLocation: 'Partner Campus Location',
    country: 'Country',
    mainCampus: 'Main Campus',
    overrideCampus: 'Override transcript campus attended with main campus',
    overrideCampusPartnerCountry: 'Override transcript campus with partner country',
    overrideWithSBS: 'Override transcript place of issue with SBS',

    // IP
    ipTitle: 'Manage IPs for Application',
    ipList: 'IP or Subnets List',
    blockIpList: 'Auto Blocked IPs',
    ipAdd: 'Add New to List',
    ip: 'IP or Subnet Mask (CIDR Format)',
    blockExcept: 'Block all IP addresses and subnets EXCEPT the list below',
    allowExcept: 'Allow all IP addresses and subnets EXCEPT the list below',
    makeBlockExcept: 'Set as Block Except.',
    makeAllowExcept: 'Set as Allow Except.',
    deleteIP: 'Delete',
    block: 'Block Except',
    allow: 'Allow Except',
    subnet: '10.1.1.0/24',
    blockIp: 'IP',
    blockAt: 'Blocked at',

    // API Tokens
    createToken: 'Create Token',
    updateTokenDescription: 'Update Token Description',
    apiTokens: 'API Tokens',
    token: 'Token',
    description:'Description',
    created: 'Created At',
    delete: 'Delete',
    create:'Create',
    update:'Update',


    // GradeFormula
    gradingScale: 'Grading Scale',
    gradingScaleTypes: 'Grading Scale Types',
    uniqueCode: 'Code',
    gradingScaleTypeCreate: 'Add New Grading Scale Type',
    gradingScaleTypeEdit: 'Edit Grading Scale Type',
    descGrade: 'Descriptive Grade',
    ectsGrade: 'ECTS Grade',
    grade: 'Grade',
    maxPercentage: 'Percentage (Max)',
    minPercentage: 'Percentage (Min)',

    programCode: 'Program Code',
    minGradingScale: 'Grading Scale Low limit reached!',
    noGradingScale: 'Please add at least one Grading Scale to continue.',
    select: 'Please select an option',
    programAssigned: 'Cannot delete, assigned to program(s).',
    emptyTitle: 'Title cannot be empty!',

    // Google 2FA
    google2fa: 'Google Two Factor Authentication (Google 2FA)',
    google2faHeading: 'Two Factor Authentication',
    google2faText: 'Two factor authentication (2FA) strengthens access security by requiring two methods (also referred to as factors) to verify your identity. Two factor authentication protects against phishing, social engineering and password brute force attacks and secures your logins from attackers exploiting weak or stolen credentials.',
    google2faEnable: 'To Enable Two Factor Authentication on your Account, you need to do following steps',
    enableStep1: 'Click on Generate Secret Button , To Generate a Unique secret QR code for your profile',
    enableStep2: 'Verify the OTP from Google Authenticator Mobile App',
    google2faEnabled: '2FA is Currently <strong>Enabled</strong> for your account.',
    google2faDisable: 'If you are looking to disable Two Factor Authentication. Please confirm your password and Click Disable 2FA Button.',
    scanBarcode: 'Scan this barcode with your Authenticator App:',
    googleBarcode: 'Google 2FA Barcode',
    enterPin: 'Enter the PIN code shown on your authenticator app below.',
    code: 'Authenticator Code',
    exclude2FA: 'Exclude 2-factor authentication by IP address or subnet',

    // Department & Position
    addInList: 'Add into List',
    inputStaff: 'Staff',
    inputProfessor: 'Professor',

    departments: 'Departments',
    departmentCreate: 'Create Department',
    departmentEdit: 'Edit Department',
    staffDepartmentList: 'Staff Department List',
    professorDepartmentList: 'Professor Department List',

    positions: 'Positions',
    positionCreate: 'Create Position',
    positionEdit: 'Edit Position',
    staffPositionList: 'Staff Position List',
    professorPositionList: 'Professor Position List',

    // hr-statuses
    hrStatusList: 'Status List',
    hrName: 'Name',
    hrStatusCreate: 'Add New Status',
    hrStatusEdit: 'Edit Status',
    hrActive: 'Active',
    hrYes: 'Yes',
    hrNo: 'No',

    programCodesTypes: 'Program Codes & Types',
    addNew: 'Add New',
    inputCode: 'Program Codes',
    inputType: 'Program Types',
    edit: 'Edit',

    // statuses
    statusList: 'Status List',
    statusCreate: 'Add New Status',
    statusEdit: 'Edit Status',
    sortOrder: 'Sort Order',
    active: 'Active',
    yes: 'Yes',
    no: 'No',


    // change password
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',

    //tuition fee
    tuition:'Tuition',
    fee:'Fee',
    createTuition: 'Create new Tuition Fee',
    feeList:'Tuition Fees',
    editTuitionFee:"Select Tuition Fee to edit",
    total_fee:"Total Fee",
    nothingToUpdate:"There is nothing to update please choose one.",
    billing_cycle:'Billing Cycle',

    //reduction type
    reduction_types: 'Reduction Types',
    reductionTypesCreate:  'Add New Reduction Type',
    reductionTypesEdit:  'Edit Reduction Type',
    reductionTypesCreate:  'Add New Reduction Type',


};

export default setting;